import React, { FunctionComponent } from "react";
import styles from "./BlockButton.module.scss";
import BlockButtonContent from "./BlockButton.interface";
import Anchor from "components/Anchor/Anchor";

const BlockButton: FunctionComponent<BlockButtonContent> = (props) => {
    const { label, link, target, className, backgroundColor, textColor, backgroundHoverColor, hoverTextColor, borderColor } = props;

    return (
        <Anchor
            to={link}
            target={target}
            className={`${styles.button} ${className || ""}`}
            style={{
                ["--btn-bg" as any]: backgroundColor?.color
                    ? backgroundColor.color.startsWith("#")
                        ? backgroundColor.color
                        : `#${backgroundColor.color}`
                    : "transparent",
                ["--btn-color" as any]: textColor?.color ? (textColor.color.startsWith("#") ? textColor.color : `#${textColor.color}`) : "#223d34",
                ["--btn-bg-hover" as any]: backgroundHoverColor?.color
                    ? backgroundHoverColor.color.startsWith("#")
                        ? backgroundHoverColor.color
                        : `#${backgroundHoverColor.color}`
                    : "transparent",
                ["--btn-color-hover" as any]: hoverTextColor?.color
                    ? hoverTextColor.color.startsWith("#")
                        ? hoverTextColor.color
                        : `#${hoverTextColor.color}`
                    : "inherit",
                ["--btn-border" as any]: borderColor?.color ? (borderColor.color.startsWith("#") ? borderColor.color : `#${borderColor.color}`) : "transparent",
            }}
        >
            <span className={styles.button_label}>{label}</span>
        </Anchor>
    );
};

export default BlockButton;
